import React from 'react';
import { connect } from 'react-redux';

import Leaflet from 'leaflet';
import DivIcon from 'react-leaflet-div-icon';
import { Map, TileLayer, Marker, Popup, LayersControl } from 'react-leaflet';

//Jquery installed and imported for Category Pane and Header menu, search bar
import $ from 'jquery';

//Import CSS Files
import '../../stylesheets/leaflet-custom.css';
import '../../stylesheets/common.css';
import '../../stylesheets/custom.css';

//Import Images
import temp from '../../assets/temp.png';
import pressure from '../../assets/pressure.png';
import windspeed from '../../assets/windspeed.png';
import precipitation from '../../assets/precipitation.png';
import cloud from '../../assets/cloud.png';

//Menu Bar Reap Benefit Logo
import reapbenefitlogo from '../../assets/images/reap-benefit-logo.png'

//Categories class file
import CategoryPane from '../category/category';

//Import Modals
import ModalAboutUs from '../modal/modalAboutUs';
import ModalFaq from '../modal/modalFaq';

import PropTypes from 'prop-types';

//Import Modal Content
import AboutUs from '../category/aboutUs';
import Faq from '../category/faq';

var data = {};

//Governance Category Markers
let govCrpIcon = new Leaflet.icon({
  iconUrl: 'markers/marker-image/marker-corporator.png',
  iconSize: [24, 24], // size of the icon
  iconAnchor: [12, 24], // point of the icon which will correspond to marker's location
  popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
});
let govMlaIcon = new Leaflet.icon({
  iconUrl: 'markers/marker-image/marker-mla.png',
  iconSize: [28, 28],
  iconAnchor: [12, 24],
  popupAnchor: [0, -24]
});
// Icon added for JanagrahaAPI markers
let potholeIcon = new Leaflet.icon({
  iconUrl: 'markers/mediajenie-icons/pothole-marker-1.png',
  iconSize: [24, 24], // size of the icon
  iconAnchor: [12, 24], // point of the icon which will correspond to marker's location
  popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
});
let wasteIcon = new Leaflet.icon({
  iconUrl: 'markers/mediajenie-icons/waste-2.png',
  iconSize: [24, 24], // size of the icon
  iconAnchor: [12, 24], // point of the icon which will correspond to marker's location
  popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
});
let sanitationIcon = new Leaflet.icon({
  iconUrl: 'markers/mediajenie-icons/sanitation-marker-2.png',
  iconSize: [24, 24], // size of the icon
  iconAnchor: [12, 24], // point of the icon which will correspond to marker's location
  popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
});
let bbmpIcon = new Leaflet.icon({
  iconUrl: 'markers/marker-blrcivic/marker-blrcivic/bbmp.jpg',
  iconSize: [24, 24], // size of the icon
  iconAnchor: [12, 24], // point of the icon which will correspond to marker's location
  popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
});
let bwssbIcon = new Leaflet.icon({
  iconUrl: 'markers/marker-blrcivic/marker-blrcivic/bwssb.jpg',
  iconSize: [24, 24], // size of the icon
  iconAnchor: [12, 24], // point of the icon which will correspond to marker's location
  popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
});
let blr1Icon = new Leaflet.icon({
  iconUrl: 'markers/marker-blrcivic/marker-blrcivic/blr1.jpeg',
  iconSize: [24, 24], // size of the icon
  iconAnchor: [12, 24], // point of the icon which will correspond to marker's location
  popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
});
let bescomIcon = new Leaflet.icon({
  iconUrl: 'markers/marker-blrcivic/marker-blrcivic/bescom.png',
  iconSize: [24, 24], // size of the icon
  iconAnchor: [12, 24], // point of the icon which will correspond to marker's location
  popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
});
let bangalorePoliceIcon = new Leaflet.icon({
  iconUrl: 'markers/marker-blrcivic/marker-blrcivic/blr_city_police.jpg',
  iconSize: [24, 24], // size of the icon
  iconAnchor: [12, 24], // point of the icon which will correspond to marker's location
  popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
});
let elcitaIcon = new Leaflet.icon({
  iconUrl: 'markers/marker-blrcivic/marker-blrcivic/elcita.png',
  iconSize: [24, 24], // size of the icon
  iconAnchor: [12, 24], // point of the icon which will correspond to marker's location
  popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
});
let elcitaToiletIcon = new Leaflet.icon({
  iconUrl: 'markers/marker-image/toilet-.png',
  iconSize: [24, 24], // size of the icon
  iconAnchor: [12, 24], // point of the icon which will correspond to marker's location
  popupAnchor: [0, -24] // point from which the popup should open relative to the iconAnchor
});


ModalAboutUs.propTypes = {
  show: PropTypes.bool
}
//For Popup Data
let lengthCounter = 0;
let positionFlag = true;
class LeafletMapFullScreen extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      lat: props.map.view.center.lat,
      lng: props.map.view.center.lng,
      zoom: props.map.view.zoom,
      governanceLayer: {},
      nearbyFeaturesAreLoading: false,
      nearbyFeaturesAreLoaded: false,
      weatherLayer: 0,
      marker_register: {},
      feature_register: {},
      moving_map: false,
      wardData: [],
      //Modal State
      isOpenAboutUs: false,
      isOpenFaq: false
    };
    this.disableMap = this.disableMap.bind(this, false);
    this.enableMap = this.enableMap.bind(this, false);
    this.onMoveStart = this.onMoveStart.bind(this, false);
    this.onMoveMap = this.onMoveMap.bind(this, false);
    this.showNextWeatherLayer = this.showNextWeatherLayer.bind(this);
    this.getCurrentWeatherLayer = this.getCurrentWeatherLayer.bind(this);
    this.getNextWeatherLayer = this.getNextWeatherLayer.bind(this);
  }
  disableMap() {
    let map = this.refs.map.leafletElement;
    map.dragging.disable();
    map.touchZoom.disable();
    map.doubleClickZoom.disable();
    map.scrollWheelZoom.disable();
    map.boxZoom.disable();
    map.keyboard.disable();
    if (map.tap) map.tap.disable();
  }
  enableMap() {
    let map = this.refs.map.leafletElement;
    map.dragging.enable();
    map.touchZoom.enable();
    map.doubleClickZoom.enable();
    map.scrollWheelZoom.enable();
    map.boxZoom.enable();
    map.keyboard.enable();
    if (map.tap) map.tap.enable();
  }

  // Modal function
  toggleModal = () => {
    this.setState({
      isOpenAboutUs: !this.state.isOpenAboutUs
    });
  }
  toggleModalFaq = () => {
    this.setState({
      isOpenFaq: !this.state.isOpenFaq
    });
  }

  checkMarkerType(feature, latlng) {
    // Condition to check type and return markers
    if ((feature.properties) && (feature.properties.type) && (feature.properties.type.id === 'govcrp')){
      return Leaflet.marker(latlng, { icon: govCrpIcon });
    }
    else if ((feature.properties) && (feature.properties.type) && (feature.properties.type.id === 'govmla'))
      return Leaflet.marker(latlng, { icon: govMlaIcon });
    else if ((feature.properties.categoryValue === 'pothole')) {
      return Leaflet.marker(latlng, { icon: potholeIcon })
    } else if ((feature.properties.categoryValue === 'garbage')) {
      return Leaflet.marker(latlng, { icon: wasteIcon });
    } else if ((feature.properties.categoryValue === 'bwssb')) {
      return Leaflet.marker(latlng, { icon: bwssbIcon });
    } else if ((feature.properties.categoryValue === 'bescom')) {
      return Leaflet.marker(latlng, { icon: bescomIcon });
    } else if ((feature.properties.categoryValue === 'blr1')) {
      return Leaflet.marker(latlng, { icon: blr1Icon });
    } else if ((feature.properties.categoryValue === 'bbmp')) {
      return Leaflet.marker(latlng, { icon: bbmpIcon });
    }else if ((feature.properties.categoryValue === 'bangalorePolice')) {
      return Leaflet.marker(latlng, { icon: bangalorePoliceIcon });
    }else if ((feature.properties.categoryValue === 'elcita')) {
      return Leaflet.marker(latlng, { icon: elcitaIcon });
    }else if ((feature.properties.categoryValue === 'elcitaToilets')) {
      return Leaflet.marker(latlng, { icon: elcitaToiletIcon });
    }  else if ((feature.properties.categoryValue === 'others')) {
      return Leaflet.marker(latlng, { icon: sanitationIcon })
    } else {
      if ((feature.properties) && (feature.properties.type) && (feature.properties.type.id === 'govjgr')) {
        return Leaflet.marker(latlng, { icon: potholeIcon });
      }
    }
  }

  arr_diff(a1) {
    let a2 = [];
    Object.key(data).forEach(keyElement => {
      data[keyElement].forEach(element => {
        a2.push(element);
      })
    })
    var a = [], diff = [];
    for (var i = 0; i < a1.length; i++) {
      a[a1[i]] = true;
    }
    for (var i = 0; i < a2.length; i++) {
      if (a[a2[i]]) {
        delete a[a2[i]];
      } else {
        a[a2[i]] = true;
      }
    }
    for (var k in a) {
      diff.push(k);
    }
    return diff;
  }

  //Initialization for labeledWardId
  labeledWardId = 0;
  // componentWillReceiveProps(nextProps) {
  //   let governanceLayer = this.state.governanceLayer;
  //   let wardNameMarkerLayer = this.state.wardNameMarkerLayer;
  //   //Displying boundaries of previous selected boundary
  //   // governanceLayer = Leaflet.geoJSON().removeFrom(this.refs.map.leafletElement);
  //   if (this.refs.map.leafletElement.hasLayer(governanceLayer))
  //     this.refs.map.leafletElement.removeLayer(this.state.governanceLayer);
  //   if ((nextProps.currentFeature)
  //     && (nextProps.currentFeature.properties)
  //     && (nextProps.currentFeature.properties.ward_id)
  //     && (nextProps.map.view.zoom > 14)) {
  //     //Remove the wardNameMarkerLayer onChange ward
  //     if (this.refs.map.leafletElement.hasLayer(wardNameMarkerLayer))
  //       // if (this.labeledWardId != nextProps.currentFeature.properties.ward_id) {
  //       this.refs.map.leafletElement.removeLayer(wardNameMarkerLayer);
  //     // }
  //     this.state.wardData[0] = nextProps.currentFeature.properties["Ward Name"];
  //     governanceLayer = Leaflet.geoJSON().addTo(this.refs.map.leafletElement);
  //     governanceLayer.addData(nextProps.currentFeature)
  //     //Condition for label checking
  //     // if (this.labeledWardId != nextProps.currentFeature.properties.ward_id) {
  //     this.labeledWardId = nextProps.currentFeature.properties.ward_id;
  //     // Adding marker with a ward name label
  //     wardNameMarkerLayer = Leaflet.marker([this.state.lat, this.state.lng], {
  //       icon: Leaflet.divIcon({
  //         className: 'text-labels',   // Set class for CSS styling
  //         html: this.state.wardData[0] + " Ward"
  //       }),
  //       draggable: false,       // Allow label dragging...?
  //       zIndexOffset: 1000     // Make appear above other map features
  //     }).addTo(this.refs.map.leafletElement);
  //     // }
  //   }
  //   if (nextProps.nearbyFeaturesAreLoading && (!nextProps.nearbyFeaturesAreLoaded)) {
  //     this.disableMap();
  //   }
  //   else {
  //     this.enableMap();
  //   }
  //   let markersLayer = this.state.markersLayer;
  //   if (this.refs.map.leafletElement.hasLayer(markersLayer))
  //     this.refs.map.leafletElement.removeLayer(markersLayer);

  //   let localData = [];
  //   if (Array.from(nextProps.map.features).length > 0 && nextProps.viewSettings && Object.keys(nextProps.viewSettings).length > 0) {
  //     let vs = nextProps.viewSettings;
  //     let featureArray = Array.from(nextProps.map.features)
  //     Object.keys(vs).forEach(key => {
  //       let element = {};
  //       element.key = key;
  //       element.value = vs[key];
  //       if (element.value == true && data[element.key] === undefined && featureArray.length > lengthCounter) {
  //         data[element.key] = featureArray.slice(lengthCounter);
  //         lengthCounter = featureArray.length;
  //       }
  //       if (element.value == true && data[element.key] !== undefined) {
  //         data[element.key].forEach(dataElement => {
  //           localData.push(dataElement);
  //         })
  //       }
  //     });
  //   }
  //   let geoJsonItem = {
  //     "type": "FeatureCollection",
  //     "features": localData.map(([id, feature]) => {
  //       return feature;
  //     })
  //   };
  //   markersLayer = Leaflet.geoJSON(geoJsonItem, {
  //     pointToLayer: this.checkMarkerType,
  //     // Onclick marker - showing marker details
  //     onEachFeature: function (feature, layer) {
  //       layer.bindPopup(
  //         '<div class="d-block center-block text-center">'
  //         + '</div><dl>'
  //         + ((feature.properties.mla === null) ? '' : (
  //           '<dt>MLA</dt><dd>'
  //           + '</dt><dd>'
  //           + feature.properties.mla
  //           + '</dd>'
  //         ))
  //         + ((feature.properties.corporator_name === null) ? '' : (
  //           '<dt>CORPORATOR</dt><dd>'
  //           + '</dt><dd>'
  //           + feature.properties.corporator_name
  //           + '</dd>'
  //         ))
  //         + ((feature.properties.age === null) ? '' : (
  //           '<table><tr><td><dt>Age&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
  //           + feature.properties.age
  //           + '</dd></td></tr></table>'
  //         ))
  //         + ((feature.properties.contact_no === null) ? '' : (
  //           '<table><tr><td><dt>Contact&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
  //           + feature.properties.contact_no
  //           + '</dd></td></tr></table>'
  //         ))
  //         + (((feature.properties.constituency === null) ||
  //           (feature.properties.constituency === "null")) ? '' : (
  //             '<dt>Constituency</dt><dd>'
  //             + feature.properties.constituency
  //             + '</dd>'
  //           ))
  //         + ((feature.properties.address === null) ? '' : (
  //           '<dt>Address</dt><dd>'
  //           + '</dt><dd>'
  //           + feature.properties.address
  //           + '</dd>'
  //         ))
  //         + ((feature.properties.pincode === null) ? '' : (
  //           '<table><tr><td><dt>Pincode.&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
  //           + feature.properties.pincode
  //           + '</dd></td></tr></table>'
  //         ))
  //         + ((feature.properties.subCategory === null) ? '' : (
  //           '<dt>Title</dt><dd>'
  //           + '</dt><dd>'
  //           + feature.properties.subCategory
  //           + '</dd>'
  //         ))
  //         + ((feature.properties.category === null) ? '' : (
  //           '<dt>Category</dt><dd>'
  //           + '</dt><dd>'
  //           + feature.properties.category
  //           + '</dd>'
  //         ))
  //         + ((feature.properties.description === null) ? '' : (
  //           '<dt>Description</dt><dd>'
  //           + '</dt><dd>'
  //           + feature.properties.description
  //           + '</dd>'
  //         ))

  //         + ((feature.properties.ward_no === null) ? '' : (
  //           '<table><tr><td><dt>Ward&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
  //           + feature.properties.ward_no
  //           + '</dd></td></tr></table>'
  //         ))
  //         + ((feature.properties.statusTitle === null) ? '' : (
  //           '<table><tr><td><dt>Status&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
  //           + feature.properties.statusTitle
  //           + '</dd></td></tr></table>'
  //         ))
  //         + '</dl>'
  //       );
  //     }
  //   }).addTo(this.refs.map.leafletElement);
  //   this.setState({
  //     governanceLayer: governanceLayer,
  //     nearbyFeaturesAreLoading: nextProps.nearbyFeaturesAreLoading,
  //     nearbyFeaturesAreLoaded: nextProps.nearbyFeaturesAreLoaded,
  //     lat: nextProps.map.view.center.lat,
  //     lng: nextProps.map.view.center.lng,
  //     zoom: nextProps.map.view.zoom,
  //     marker_register: nextProps.map.marker_register,
  //     feature_register: nextProps.map.features,
  //     markersLayer: markersLayer,
  //     wardNameMarkerLayer: wardNameMarkerLayer,
  //     viewSettings: nextProps.viewSettings,
  //   });
  // }
  componentWillReceiveProps(nextProps) {
    let governanceLayer = this.state.governanceLayer;
    let wardNameMarkerLayer = this.state.wardNameMarkerLayer;
    let markersLayer = this.state.markersLayer;
    if (this.refs.map.leafletElement.hasLayer(markersLayer))
      this.refs.map.leafletElement.removeLayer(markersLayer);

    let localData = [];
    if (Array.from(nextProps.map.features).length > 0 && nextProps.viewSettings && Object.keys(nextProps.viewSettings).length > 0) {
      let vs = nextProps.viewSettings;
      let featureArray = Array.from(nextProps.map.features)
      Object.keys(vs).forEach(key => {
        if (key !== 'air') {
          let element = {};
          element.key = key;
          element.value = vs[key];
          if (element.value == true && data[element.key] === undefined && featureArray.length > lengthCounter) {
            data[element.key] = featureArray.slice(lengthCounter);
            lengthCounter = featureArray.length;
          }
          if (element.value == true && data[element.key] !== undefined) {
            data[element.key].forEach(dataElement => {
              localData.push(dataElement);
            })
          }
        }
      });
    }
    let geoJsonItem = {
      "type": "FeatureCollection",
      "features": localData.map(([id, feature]) => {
        return feature;
      })
    };
    markersLayer = Leaflet.geoJSON(geoJsonItem, {
      pointToLayer: this.checkMarkerType,
      // Onclick marker - showing marker details
      onEachFeature: function (feature, layer) {
        layer.bindPopup(
          '<div class="d-block center-block text-center">'
          + '</div><dl>'
          + ((feature.properties.mla == null) ? '' : (
            '<dt>MLA</dt><dd>'
            + '</dt><dd>'
            + feature.properties.mla
            + '</dd>'
          ))
          + ((feature.properties.corporator_name == null) ? '' : (
            '<dt>CORPORATOR</dt><dd>'
            + '</dt><dd>'
            + feature.properties.corporator_name
            + '</dd>'
          ))
          + ((feature.properties.age == null) ? '' : (
            '<table><tr><td><dt>Age&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
            + feature.properties.age
            + '</dd></td></tr></table>'
          ))
          + ((feature.properties.contact_no == null) ? '' : (
            '<table><tr><td><dt>Contact&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
            + feature.properties.contact_no
            + '</dd></td></tr></table>'
          ))
          + (((feature.properties.constituency == null) ||
            (feature.properties.constituency == "null")) ? '' : (
              '<dt>Constituency</dt><dd>'
              + feature.properties.constituency
              + '</dd>'
            ))
          + ((feature.properties.address == null) ? '' : (
            '<dt>Address</dt><dd>'
            + '</dt><dd>'
            + feature.properties.address
            + '</dd>'
          ))
          + ((feature.properties.pincode == null) ? '' : (
            '<table><tr><td><dt>Pincode.&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
            + feature.properties.pincode
            + '</dd></td></tr></table>'
          ))
          + ((feature.properties.subCategory == null) ? '' : (
            '<dt>Title</dt><dd>'
            + '</dt><dd>'
            + feature.properties.subCategory
            + '</dd>'
          ))
          + ((feature.properties.category == null) ? '' : (
            '<table><tr><td><dt>Category&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
            + feature.properties.category
            + '</dd></td></tr></table>'
          ))
          + ((feature.properties.description == null) ? '' : (
            '<dt>Description</dt><dd>'
            + '</dt><dd>'
            + feature.properties.description
            + '</dd>'
          ))

          + ((feature.properties.ward_name == null) ? '' : (
            '<table><tr><td><dt>Ward name&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
            + feature.properties.ward_name
            + '</dd></td></tr></table>'
          ))

          + ((feature.properties.ward_no == null) ? '' : (
            '<table><tr><td><dt>Ward number&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
            + feature.properties.ward_no
            + '</dd></td></tr></table>'
          ))
          + ((feature.properties.statusTitle == null) ? '' : (
            '<table><tr><td><dt>Status&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
            + feature.properties.statusTitle
            + '</dd></td></tr></table>'
          ))
          + ((feature.properties.civic_body_name == null) ? '' : (
            '<table><tr><td><dt>Civic Body&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
            + feature.properties.civic_body_name
            + '</dd></td></tr></table>'
          ))
          + ((feature.properties.civic_body_division_type == null) ? '' : (
            '<table><tr><td><dt>Division Type&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
            + feature.properties.civic_body_division_type
            + '</dd></td></tr></table>'
          ))
          + ((feature.properties.location_name == null) ? '' : (
            '<table><tr><td><dt>Location at&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
            + feature.properties.location_name
            + '</dd></td></tr></table>'
          ))
          + ((feature.properties.location_address == null) ? '' : (
            '<table><tr><td><dt>Address&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
            + feature.properties.location_address
            + '</dd></td></tr></table>'
          ))
          + ((feature.properties.center_manager_contact_number == null) ? '' : (
            '<table><tr><td><dt>Location Contact Number(s)&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
            + feature.properties.center_manager_contact_number
            + '</dd></td></tr></table>'
          ))+ ((feature.properties.title == null) ? '' : (
            '<table><tr><td><dt>Title&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
            + feature.properties.title
            + '</dd></td></tr></table>'
          ))+ ((feature.properties.status == null) ? '' : (
            '<table><tr><td><dt>Status&nbsp;&nbsp;&nbsp;&nbsp;</dt></td><td><dd>'
            + feature.properties.status
            + '</dd></td></tr></table>'
          ))
          + '</dl>'
        );
      }
    }).addTo(this.refs.map.leafletElement);
    this.setState({
      governanceLayer: governanceLayer,
      nearbyFeaturesAreLoading: nextProps.nearbyFeaturesAreLoading,
      nearbyFeaturesAreLoaded: nextProps.nearbyFeaturesAreLoaded,
      lat: nextProps.map.view.center.lat,
      lng: nextProps.map.view.center.lng,
      zoom: nextProps.map.view.zoom,
      marker_register: nextProps.map.marker_register,
      feature_register: nextProps.map.features,
      markersLayer: markersLayer,
      wardNameMarkerLayer: wardNameMarkerLayer,
      viewSettings: nextProps.viewSettings,
    });
  }
  componentDidMount() {
    //Get the boundary data from json
    let boundaryFeatures = require('../../helpers/BBMP-Wards-New-Formatted-Opencity-ELCITA.json');
    //Creating layer for boundaries
    let governanceLayer = this.state.governanceLayer;
    //Creating layer for ward names
    let wardNameMarkerLayer = this.state.wardNameMarkerLayer;

    governanceLayer = Leaflet.geoJSON().addTo(this.refs.map.leafletElement);
    //Iterate over the wardboundaries data and addData to boundary
    for (var key in boundaryFeatures) {
      if (boundaryFeatures.hasOwnProperty(key)) {
        var val = boundaryFeatures[key];
        // Get the center of the polygon
        let latlng = this.getCentroid(val.geometry.coordinates[0]);
        governanceLayer.addData(val);
        wardNameMarkerLayer = Leaflet.marker(latlng, {
          icon: Leaflet.divIcon({
            className: 'text-labels',   // Set class for CSS styling
            html: val.properties["Ward Name"] + " Ward"
          }),
          draggable: false,       // Allow label dragging...?
          zIndexOffset: 1000     // Make appear above other map features
        }).addTo(this.refs.map.leafletElement);
      }
    }

    this.onMoveMap();

    $(document).ready(function () {
      $(function () {
        $("#hamburger-menu").click(function () {
          $("#nav-links").slideToggle();
        });
      });
      $(function () {
        function elementsHeight() {
          let windowHeight = $(window).height();
          let documentHeight = $(document).height();
          $(".gmap-wrapper").height(windowHeight);
        }
        elementsHeight();
        $(window).resize(function () {
          elementsHeight();
        });
      });
    });

  }


  // Find the center of the polygon.
  getCentroid = function (polygon) {
    let x = 0,
      y = 0,
      i,
      j,
      f,
      point1,
      point2;
    let points = polygon || [];
    let length = points.length;
    for (i = 0, j = length - 1; i < length; j = i, i++) {
      point1 = { x: points[i][0], y: points[i][1] };
      point2 = { x: points[j][0], y: points[j][1] }
      f = point1.x * point2.y - point2.x * point1.y;
      x += (point1.x + point2.x) * f;
      y += (point1.y + point2.y) * f;
    }

    f = this.area(points) * 6;

    return [y / f, x / f];
  };

  area = function (points) {
    let area = 0,
      i,
      j,
      point1,
      point2;

    for (i = 0, j = points.length - 1; i < points.length; j = i, i++) {
      point1 = { x: points[i][0], y: points[i][1] };
      point2 = { x: points[j][0], y: points[j][1] }
      area += point1.x * point2.y;
      area -= point1.y * point2.x;
    }
    area /= 2;

    return area;
  };
  shouldComponentUpdate() {
    return ((!this.props.nearbyFeaturesAreLoading)
      && (this.props.nearbyFeaturesAreLoaded)
    );
  }
  onMoveStart() {
    this.setState({
      moving_map: true
    });
  }
  onMoveMap() {
    this.setState({
      moving_map: false
    });
    let bounds = this.refs.map.leafletElement.getBounds();
    let center = this.refs.map.leafletElement.getCenter();
    let radius = this.refs.map.leafletElement.distance(bounds._northEast, bounds._southWest) / 2;
    let zoom = this.refs.map.leafletElement.getZoom();
    this.props.map.setView(center, zoom, radius, bounds);
  }
  showNextWeatherLayer() {
    let weatherLayer = this.state.weatherLayer;
    this.setState({
      weatherLayer: ((weatherLayer + 1) % 6)
    });
  }
  getCurrentWeatherLayer() {
    let weatherLayer = this.state.weatherLayer;
    switch (weatherLayer) {
      case 1: {
        return "temp_new";
      }
      case 2: {
        return "pressure_new";
      }
      case 3: {
        return "wind_new";
      }
      case 4: {
        return "precipitation_new";
      }
      case 5: {
        return "clouds_new";
      }
    }
  }
  getNextWeatherLayer() {
    let weatherLayer = this.state.weatherLayer;
    switch (weatherLayer) {
      case 0: {
        return <img src={temp} className="weather-layer-selector-img" />;
      }
      case 1: {
        return <img src={pressure} className="weather-layer-selector-img" />;
      }
      case 2: {
        return <img src={windspeed} className="weather-layer-selector-img" />;
      }
      case 3: {
        return <img src={precipitation} className="weather-layer-selector-img" />;
      }
      case 4: {
        return <img src={cloud} className="weather-layer-selector-img" />;
      }
      default: {
        return null;
      }
    }
  }

  render() {
    if (positionFlag === true) {
      this.state.lat = 12.9244925;
      this.state.lng = 77.5905634;
      positionFlag = false;
    }
    const position = [this.state.lat, this.state.lng];
    let markers = [];
    (Object.entries(this.state.marker_register)).map(([component_key, marker_entries]) => {
      if (this.state.viewSettings[component_key]) {
        marker_entries.map((marker) => {
          markers.push(marker);
        });
      }
    });

    return <div>
      <div className="gmap-wrapper">
        <div id='gmap_canvas' className="gmap_inner"></div>
        <div className="search-box-container">
          <div className="header-container">
            <div className="logo-nav">
              <div className="logo">
                <img src={reapbenefitlogo} alt="reap benefit" />
              </div>
              <div className="nav" id="hamburger-menu">
                <span className="menu-line" style={{ marginLeft: 10 }}></span>
              </div>
            </div>
            <div className="nav-links" id="nav-links">
              <ul className="no-padding no-margin">
                <li><a href="#">Home</a></li>
                <li><a onClick={this.toggleModal}>About Us</a></li>
                <ModalAboutUs show={this.state.isOpenAboutUs}
                  onClose={this.toggleModal}>
                  {/* Modal Content */}
                  <AboutUs />
                </ModalAboutUs>
                <li><a onClick={this.toggleModalFaq}>Faq</a></li>
                <ModalFaq show={this.state.isOpenFaq}
                  onClose={this.toggleModalFaq}>
                  <Faq />
                </ModalFaq>
                <li><a href="#">Contact</a></li>
              </ul>
            </div>
          </div>
          <div className="search-box-container-header">
            {/* <form action="#" method="post"> */}
            <div className="search-term">
              <input list="comingsoon" id="search-box" className="search-box" placeholder="Enter Your Location/Query" name="search-name" />
              <datalist id="comingsoon" >
                <option value="Coming Soon" />
              </datalist>
              {/* <input type="text" id="search-box" className="search-box" placeholder="Enter Your Location/Query" name="search-name" /> */}
              <input type="submit" className="search-icon" value="search" onClick={this.comingSoonAlert} />
            </div>
            {/* </form> */}
          </div>
          <CategoryPane />
        </div>
      </div>

      <div className="leaflet-map">
        <Map center={position} zoom={this.state.zoom} zoomControl={false}
          zoomDelta={0.1} zoomSnap={0.1} minZoom={14} 
          maxBoundsViscosity={0.5} onMoveStart={this.onMoveStart}
          className="leaflet-container-fullscreen" ref="map"
          onMoveEnd={this.onMoveMap} id="leafletMapFullScreen">
          {
            ((this.state.zoom > 14) && (!this.state.moving_map)) ?
              <DivIcon position={position} className="leaflet-inner-div-class">
                <i className="fas fa-crosshairs" />
              </DivIcon> : null
          }
          <TileLayer
            attribution="Map data &amp;copy <a href=&quot;http://osm.org/copyright&quot;>2018 Google</a> contributors"
            // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            // url= "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&m"
            // url="http://mt0.google.com/vt/lyrs=m,traffic&x={x}&y={y}&z={z}"
            // url="https://mts1.google.com/vt/lyrs=m@186112443&hl=x-local&src=app&x={x}&y={y}&z={z}&s=Galile"
            // h = roads only
            // m = standard roadmap
            // p = terrain
            // r = somehow altered roadmap
            // s = satellite only
            // t = terrain only
            // y = hybrid
            url="https://mt.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
          />
          {
            (this.state.weatherLayer > 0) ?
              <TileLayer
                attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                url={"https://tile.openweathermap.org/map/"
                  + (this.getCurrentWeatherLayer())
                  + "/{z}/{x}/{y}.png?appid=0dcb1c01fd48a7626fc9e40fabf8730e"}
              /> :
              null
          }
          {
            ((markers) && (markers.length)) ?
              (markers.map((marker) => {
                return <DivIcon key={marker.key}
                  position={marker.position}
                  className={marker.className}>

                  {
                    marker.components.map((component) => {
                      return component;
                    })
                  }
                  <Popup className={marker.popup.className}>
                    <span className="text-center">
                      {
                        marker.popup.components.map((component) => {
                          return component;
                        })
                      }
                    </span>
                  </Popup>
                </DivIcon>;
              })) :
              null
          }
        </Map>
        {
          ((this.state.zoom > 14) && (this.state.moving_map)) ? (
            <div className="screen-center-crosshairs">
              <i className="fas fa-crosshairs" />
            </div>
          ) : null
        }
      </div>
    </div >

  }
}

export default connect((state) => {
  return ({
    map: state.map,
    currentFeature: state.governanceData.currentFeature,
    nearbyFeaturesAreLoading: state.governanceData.isLoading,
    nearbyFeaturesAreLoaded: state.governanceData.loadComplete,
    viewSettings: state.viewSettings
  });
})(LeafletMapFullScreen);


// WEBPACK FOOTER //
// ./src/components/maps/LeafletMapFullScreen.js